import TransactionStatusClass from "@components/classes/TransactionStatusClass";

export type PillTone = "green" | "red" | "amber" | "blue" | "purple" | "gray";

const statusClass = new TransactionStatusClass();

const TONE_STYLES: Record<PillTone, { bg: string; text: string }> = {
  green: { bg: "bg-[#E2F6E8]", text: "#66AD7B" },
  red: { bg: "bg-[#FFE8E8]", text: "#D61C1C" },
  amber: { bg: "bg-[#FFF0E4]", text: "#FE961C" },
  blue: { bg: "bg-[#C7DBFF]", text: "#1D4ED8" },
  purple: { bg: "bg-[#E2D4FF]", text: "#7C3AED" },
  gray: { bg: "bg-[#F1F3F5]", text: "#686E92" },
};

export default function DataPill({
  value,
  label,
  tone,
  icon,
}: {
  value?: string | number | boolean | null;
  label?: string;
  tone?: PillTone;
  icon?: string;
}) {
  const normalized =
    typeof value === "boolean"
      ? value
        ? "active"
        : "inactive"
      : String(value ?? "").toLowerCase();

  if (!normalized && !label) {
    return <span className="text-[10px] text-text-base">-</span>;
  }

  const mapped = normalized
    ? statusClass.getTransactionStatusIcon(normalized)
    : null;
  const hasMappedColor = !!mapped && mapped.bgColor !== "bg-icon-white";
  const toneStyle = tone ? TONE_STYLES[tone] : null;
  const background =
    toneStyle?.bg ||
    (hasMappedColor && mapped ? mapped.bgColor : TONE_STYLES.gray.bg);
  const textColor =
    toneStyle?.text ||
    (hasMappedColor && mapped && mapped.textColor.startsWith("#")
      ? mapped.textColor
      : TONE_STYLES.gray.text);
  const displayLabel =
    label ||
    (normalized ? normalized.replaceAll("_", " ").toUpperCase() : "-");

  return (
    <span
      className={`inline-flex h-[20px] items-center justify-center gap-1 whitespace-nowrap rounded px-[6px] text-[10px] font-medium ${background}`}
      style={{ color: textColor }}
    >
      {icon && (
        <span className="material-symbols-outlined text-[13px] leading-none">
          {icon}
        </span>
      )}
      {displayLabel}
    </span>
  );
}
